// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    anyAiModelAfter: {
        type: FIELD_TYPES.TEXT,
        label: "Any Ai Model After",
        translatable: true
    },
    anyAiModelBefore: {
        type: FIELD_TYPES.TEXT,
        label: "Any Ai Model Before",
        translatable: true
    },
    anyAiModelParagraph: {
        type: FIELD_TYPES.TEXT,
        label: "Any Ai Model Paragraph",
        translatable: true
    },
    buttonGetStartedText: {
        type: FIELD_TYPES.TEXT,
        label: "Button Get Started Text",
        translatable: true
    },
    infiniteKnowledgeAfter: {
        type: FIELD_TYPES.TEXT,
        label: "Infinite Knowledge After",
        translatable: true
    },
    infiniteKnowledgeBefore: {
        type: FIELD_TYPES.TEXT,
        label: "Infinite Knowledge Before",
        translatable: true
    },
    infiniteKnowledgeParagraph: {
        type: FIELD_TYPES.TEXT,
        label: "Infinite Knowledge Paragraph",
        translatable: true
    },
    openEcosystemAfter: {
        type: FIELD_TYPES.TEXT,
        label: "Open Ecosystem After",
        translatable: true
    },
    openEcosystemBefore: {
        type: FIELD_TYPES.TEXT,
        label: "Open Ecosystem Before",
        translatable: true
    },
    openEcosystemParagraph: {
        type: FIELD_TYPES.TEXT,
        label: "Open Ecosystem Paragraph",
        translatable: true
    },
    sectionParagraph: {
        type: FIELD_TYPES.TEXT,
        label: "Section Paragraph",
        translatable: true
    },
    sectionTagline: {
        type: FIELD_TYPES.TEXT,
        label: "Section Tagline",
        translatable: true
    },
    sectionTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Section Title",
        translatable: true
    },
    unifiedDataAfter: {
        type: FIELD_TYPES.TEXT,
        label: "Unified Data After",
        translatable: true
    },
    unifiedDataBefore: {
        type: FIELD_TYPES.TEXT,
        label: "Unified Data Before",
        translatable: true
    },
    unifiedDataParagraph: {
        type: FIELD_TYPES.TEXT,
        label: "Unified Data Paragraph",
        translatable: true
    },
    anyAiModelBgImage: {
        type: FIELD_TYPES.NESTED,
        label: "Any Ai Model Bg Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    image: {
        type: FIELD_TYPES.NESTED,
        label: "Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    image2: {
        type: FIELD_TYPES.NESTED,
        label: "Image 2",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    image4: {
        type: FIELD_TYPES.NESTED,
        label: "Image 4",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    image5: {
        type: FIELD_TYPES.NESTED,
        label: "Image 5",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    image7: {
        type: FIELD_TYPES.NESTED,
        label: "Image 7",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    image8: {
        type: FIELD_TYPES.NESTED,
        label: "Image 8",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    infiniteKnowledgeBgImage: {
        type: FIELD_TYPES.NESTED,
        label: "Infinite Knowledge Bg Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    unifiedDataBgImage: {
        type: FIELD_TYPES.NESTED,
        label: "Unified Data Bg Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    link: {
        type: FIELD_TYPES.NESTED,
        label: "Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
};
